export const responsiveSpace = {
  md: 6,
  xs: 3
}